module.exports = __webpack_public_path__ + "static/media/background-grid-color.2ca7aa5b.svg";